module.exports = __webpack_public_path__ + "img/mac.ae829e44.png";